import type { ReactNode } from "react";
import "./Forbidden.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Forbidden(): ReactNode {
  const { t } = useTranslation();
  return (
    <div className="forbidden">
      <h3>{t("common:defaultPages.forbidden")}</h3>
      <Link to="/content/currentuser/?task=viewportal" reloadDocument={true}>
        {t("common:messages.backHome")}
      </Link>
    </div>
  );
}
